<button mat-icon-button [matMenuTriggerFor]="languageMenu" aria-label="Select language" fxLayoutAlign="center center">
  <span style="font-size: medium;">{{ selectedLanguage.id.toUpperCase() }}</span>
</button>
<mat-menu #languageMenu="matMenu">
  @for (language of languages; track language) {
    <button mat-menu-item (click)="updateSelectedLanguage(language)">
      <div fxLayoutAlign="start center" fxLayoutGap="10px">
        <span>
          {{ language.text }}
        </span>
      </div>
    </button>
  }
</mat-menu>
